import { render } from "./Auth2faDeActivate.vue?vue&type=template&id=1427aa11&scoped=true"
import script from "./Auth2faDeActivate.vue?vue&type=script&lang=js"
export * from "./Auth2faDeActivate.vue?vue&type=script&lang=js"

import "./Auth2faDeActivate.vue?vue&type=style&index=0&id=1427aa11&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1427aa11"]])

export default __exports__